import { IMenuItem } from '@/common/models/menuItem';
import { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './../../organisms/sidebar/sidebar';
import styles from './main.module.scss';
import { useMediaQuery, useTheme } from '@mui/material';
import { SidebarContext } from '@/common/hooks/useSidebar';  

export const Main = (props: { menuItems: IMenuItem[] }) => {
   const SIDEBAR_KEY = 'eves_sidebar_open';
   const getSavedOpen = () => {
      try { return localStorage.getItem(SIDEBAR_KEY) !== 'false'; } catch { return true; }
   };
   const [isSideBarOpen, setIsSideBarOpen] = useState(getSavedOpen);    
   const theme = useTheme();
   const selfToggle = useMediaQuery(theme.breakpoints.down(990));
   const sideBarOpenToggle = () => {
      const next = !isSideBarOpen;
      setIsSideBarOpen(next);
      if (selfToggle) return;
      try {
         localStorage.setItem(SIDEBAR_KEY, String(next));
      } catch {
         // storage unavailable (e.g. private mode); keep in-memory state only
      }  
   };

   useEffect(() => {
      if (selfToggle) {
         setIsSideBarOpen(false);
      } else {
         setIsSideBarOpen(getSavedOpen());
      }
   }, [selfToggle]);

   return (
      <SidebarContext.Provider value={{ isOpen: isSideBarOpen, toggle: sideBarOpenToggle }}>
         <div className={styles.main}>
            <Sidebar
               menuItems={props.menuItems}
               isOpen={isSideBarOpen}
            />
            <div
               id='main_body_id'
               className={styles.mainBody}
            >
               <Outlet />
            </div>
         </div>
      </SidebarContext.Provider>
   );
};
